import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import App from './App';

//const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(
//  <React.StrictMode>
//    <App />
//  </React.StrictMode>
//);
import { isApp } from './utils/platform';

const startApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);
};

if (isApp) {
  // Wait for Cordova to bridge the native gap
  document.addEventListener('deviceready', startApp, false);
} else {
  // Just launch immediately for the website
  startApp();
}